import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Representative state for registration
 * Stores representative/contact person information
 */
export interface RegistrationRepState {
  repName: string | null;
  repTitle: string | null;
}

const initialState: RegistrationRepState = {
  repName: null,
  repTitle: null,
};

/**
 * Generic reducer factory for simple field updates
 * Eliminates duplication for setters that just assign a value
 */
const createFieldSetter = <K extends keyof RegistrationRepState>(field: K) => {
  return (state: RegistrationRepState, action: PayloadAction<RegistrationRepState[K]>) => {
    state[field] = action.payload;
  };
};

const repSlice = createSlice({
  name: "rep",
  initialState,
  reducers: {
    // Representative field setters - Unwrapped payload pattern
    setRepName: createFieldSetter("repName"),
    setRepTitle: createFieldSetter("repTitle"),

    /**
     * Bulk update multiple fields at once
     * Useful for hydrating state from API response
     */
    hydrateRegistrationRepState: (state, action: PayloadAction<Partial<RegistrationRepState>>) => {
      return { ...state, ...action.payload };
    },

    /**
     * Reset to initial state
     */
    resetRegistrationRepState: () => initialState,
  },
});

export const {
  setRepName,
  setRepTitle,
  hydrateRegistrationRepState,
  resetRegistrationRepState,
} = repSlice.actions;

export default repSlice.reducer;
